module.exports = __webpack_public_path__ + "static/img/ISAlogo200px.3baebb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ISAlogo200px.png
// module id = n26P
// module chunks = 0